import { render, staticRenderFns } from "./ApuracaoContratoFiltrosObrigatorios.vue?vue&type=template&id=61bfe5b2"
import script from "./ApuracaoContratoFiltrosObrigatorios.vue?vue&type=script&lang=js"
export * from "./ApuracaoContratoFiltrosObrigatorios.vue?vue&type=script&lang=js"
import style0 from "./ApuracaoContratoFiltrosObrigatorios.vue?vue&type=style&index=0&id=61bfe5b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports